import React, { useState, useRef } from "react";
import Star from "../../Stars/Star";
import "./FormA.css";
import { MdDeleteOutline } from "react-icons/md";
import { FaPlus } from "react-icons/fa";


const FormBcomponent = ({ jsonarray, clientratings }) => {
  // const [rowcount, setRowcount] = useState(1);
  const [starvalues, setStarvalues] = useState([]);
  const [managerRating, setManagerRating] = useState(0);
  const [clientRating, setClientRating] = useState(0);

  let tableHeader_cells = {
    colm_1: "RATING FACTORS",
    colm_2: "Staff Ratings (1,2,3,4)",
    colm_3: "Manager's Ratings (1,2,3,4)",
  };

  // console.log(partascore);

  const handleSeleted = (newValue, index) => {
    let varyArray;
    setStarvalues((prevArray) => {
      const newArray = [...prevArray]; // Create a copy of the original array
      newArray[index] = newValue; // Update the value at the specified index
      varyArray = newArray;
      return newArray; // Set the state with the updated array
    });

    setClientRating(
      varyArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      )
    );

    clientratings({
      socreobtained: varyArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      ),
      scoreobtainable: jsonarray.kpis.length * 4,
    });
  };

  // const handleSeleted = (newValue, index) => {
  //   console.log(newValue, index)
  //   let varyArray;
  //   setStarvalues((prevArray) => {
  //     const newArray = [...prevArray]; // Create a copy of the original array
  //     newArray[index] = newValue; // Update the value at the specified index
  //     varyArray = newArray;
  //     return newArray; // Set the state with the updated array
  //   });

  //   setManagerRating(
  //     varyArray.reduce(
  //       (accumulator, currentValue) => accumulator + currentValue,
  //       0
  //     )
  //   );
  // };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   // setExperbuild({ ...experbuild, [name]: value });
  // };

  const handleCommentChange = () => {};

  const [text, setText] = useState("");
  const textareaRef = useRef(null);

  const handleChange = (event) => {
    setText(event.target.value);
    adjustTextareaHeight();
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  return (
    <div className="w-full">
      <table>
        <thead>
          <tr className="bg-[#C4BC96]">
            <th
              scope="col"
              className="text-center w-[40%] min-w-[150px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>RATING FACTORS</b> <br />
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[150px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Staff Ratings (1,2,3,4)</b> <br />
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[150px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Manager's Ratings (1,2,3,4)</b> <br />
            </th>
          </tr>
        </thead>

        <tbody>
          {jsonarray.kpis?.map((items, index) => {
            return (
              <tr>
                <td data-label={tableHeader_cells.colm_1}>
                  <div className="flex flex-col items-start justify-start min-h-[150px] w-full">
                    <b>
                      <p>{items?.rating_factor?.title}</p>
                    </b>
                    <p className="text-left">
                      {items?.rating_factor?.description}
                    </p>
                  </div>
                </td>

                <td data-label={tableHeader_cells.colm_2}>
                  <div className="flex flex-col items-start justify-start min-h-[150px] w-full">
                    <div className="w-full h-[30px] flex justify-start">
                      <Star
                        currentrating={items?.staff_rating?.rate}
                        selectedstar={(e) => handleSeleted(e, index)}
                        status={false}
                      />
                    </div>

                    <div className="w-full h-full flex flex-col items-start justify-start border_class">
                      <p className="mb-1 comment_class">COMMENT</p>
                      <textarea
                        ref={textareaRef}
                        className="text-left w-full outline-none"
                        onChange={handleChange}
                        value={items?.staff_rating?.comment}
                        style={{
                          resize: "none",
                          minHeight: "100px", // Set your desired minimum height here
                          maxHeight: "300px", // Set your desired maximum height here
                          overflowY: "auto",
                        }}
                      />
                    </div>
                  </div>
                </td>

                <td data-label={tableHeader_cells.colm_3}>
                  <div className="flex flex-col items-start justify-start min-h-[150px] w-full">
                    <div className="w-full h-[30px] flex justify-start">
                      <Star
                        currentrating={items?.supervisor_rating?.rate}
                        selectedstar={(e) => handleSeleted(e, index)}
                        status={true}
                      />
                    </div>

                    <div className="w-full h-full flex flex-col items-start justify-start border_class">
                      <p className="mb-1 comment_class">COMMENT</p>
                      <textarea
                        className="text-left w-full outline-none"
                        onChange={() => handleCommentChange}
                        value={items?.supervisor_rating?.comment}
                        style={{
                          resize: "none",
                          minHeight: "100px", // Set your desired minimum height here
                          maxHeight: "300px", // Set your desired maximum height here
                          overflowY: "auto",
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}

          <tr>
            <td data-label={tableHeader_cells.colm_1}>
              {" "}
              <b>Total</b>{" "}
            </td>
            <td data-label={tableHeader_cells.colm_2}> {clientRating} </td>
            <td data-label={tableHeader_cells.colm_3}> {managerRating} </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FormBcomponent;
